import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'

export type LocationProps = {
  startLocation?: string | null
  endLocation?: string | null
  typeOfExperience?: string
  variant?: 'single' | 'start_and_end' | 'with_experience'
}

function TourV2Location(props: LocationProps) {
  const { endLocation, startLocation, typeOfExperience, variant = 'single' } = props
  const intl = useIntl()

  const startsEndsInLabel = intl.formatMessage(
    {
      id: 'fBeh124qft',
      defaultMessage: 'Starts in {startLocation}, Ends in {endLocation}',
      description: 'Tour location label showing distinct start and end locations',
    },
    { startLocation, endLocation },
  )
  const locationWithExperienceLabel = <FormattedMessage
    id="tZkUAjB/Yy"
    defaultMessage="{startLocation} · <secondary>{typeOfExperience}</secondary>"
    description="Tour location with experience type separated by middle dot on offer card"
    values={{
      startLocation,
      typeOfExperience,
      secondary: (chunks) => <Caption as="span" variant="large" colour="neutral-two">{chunks}</Caption>,
    }}
  />

  return (
    <Group direction="horizontal" verticalAlign="center" gap={4}>
      {variant === 'single' && (
        <Caption variant="large" colour="neutral-one">
          {startLocation}
        </Caption>
      )}
      {variant === 'start_and_end' && (
        <Caption variant="large" colour="neutral-one">
          {startsEndsInLabel}
        </Caption>
      )}
      {variant === 'with_experience' && (
        <Caption variant="large" colour="neutral-one">
          {typeOfExperience
            ? locationWithExperienceLabel
            : startLocation}
        </Caption>
      )}
    </Group>
  )
}
export default TourV2Location
